import { Checkbox, CheckboxProps, Modal, Row } from "antd";
import { Dispatch, SetStateAction, useEffect, useState } from "react";

import ButtonLiderar from "../ButtonLiderar/ButtonLiderar";
import "./style.less";
import { ILifePolicy } from "../../services/ILifePolicy";
import GraphqlService from "../../services/graphql/GraphqlService";
import { CustomMessage } from "../../shared";

interface IModalLifePolicyProps {
  modalState: {
    isOpen: boolean;
  };
  setModalState: Dispatch<
    SetStateAction<{
      isOpen: boolean;
    }>
  >;
  onOk: () => any;
}

const ModalLifePolicy = (props: IModalLifePolicyProps): JSX.Element => {
  const { modalState, setModalState, onOk } = props;
  const [disabled, setDisabled] = useState<boolean>(true);
  const [sumaAsegurada, setSumaAsegurada] = useState<string>("-");
  const { customRequest, Query } = GraphqlService();
  const { messageError } = CustomMessage();
  
  const onChange: CheckboxProps['onChange'] = (e) => {
    setDisabled(!e.target.checked)
  };

  const getSumaAsegurada = async () => {
    try {
      const data: ILifePolicy = await customRequest({
        query: Query.lifePolicy,
      });
      if (data) {
        const formated = parseFloat(data.coverage).toLocaleString();
        setSumaAsegurada(formated);
      }
    } catch (error) {
      messageError({
        context: "Emission - life_policy_sum",
        message: "Error al obtener suma asegurada",
      });
    }
  }

  useEffect(() => {
    getSumaAsegurada();
  }, []);

  return (
    <Modal
      title="Atención"
      className="modal-collection"
      visible={modalState.isOpen}
      onCancel={() => setModalState({ isOpen: false })}
      footer={[
        <ButtonLiderar
          key={0}
          color="white"
          buttonName="Cancelar"
          onClick={() =>
            setModalState({ isOpen: false })
          }
        />,
        <ButtonLiderar
          key={1}
          color="violet"
          buttonName="Confirmar"
          disabled={disabled}
          onClick={() =>
            onOk()
          }
        />
      ]}
    >
      <p>EN CASO DE CUMPLIR CON LOS REQUISITOS DETERMINADOS POR LA ASEGURADORA, SE SOLICITA LA EMISIÓN DE UN SEGURO DE VIDA INDIVIDUAL AMPARANDO AL ASEGURADO DECLARADO EN LA PRESENTE PROPUESTA, SIENDO BENEFICIARIOS LOS HEREDEROS LEGALES. Esta designación puede ser modificada a pedido expreso del Asegurado.</p>
      <p>Suma del seguro de vida:<b> $ {sumaAsegurada}</b></p>
      <Row>
        <Checkbox onChange={onChange}>Confirmar solicitud de seguro de vida</Checkbox>
      </Row>
    </Modal>
  );
};

export default ModalLifePolicy;
